export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/5-0f358a21d05aef911925ba647eb82a7f.png";